import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import './product-trial-info-lozenge.scss';
import { pluralize } from '@css-xp/ppc-utils';

export const ProductTrialInfo = ({ trialLength, isApp = false }: { trialLength?: string | null; isApp?: boolean }) => {
  if (trialLength) {
    const lozengeText = `${pluralize(Number(trialLength), 'DAY')} TRIAL`;
    if (isApp) {
      return (
        <div className="order-review-container-row-container">
          <p className="selected-app-pricing-details">
            <Lozenge appearance={'inprogress'} testId="product-trial-info-lozenge">
              {lozengeText}
            </Lozenge>
          </p>
        </div>
      );
    } else {
      return (
        <div className="order-review-container-row-container">
          <Lozenge appearance={'inprogress'} testId="product-trial-info-lozenge">
            {lozengeText}
          </Lozenge>
        </div>
      );
    }
  }

  return <></>;
};
